/*
  Displays the rate schedules associated with a specific rate schedule group.
  Displayed cards have the following abilities:
  1. Cannot be selected when clicked on.
  2. Does not indicate which is the active rate schedule.
  3. Can display the additional charges modal.
 */
import {RateScheduleCard} from 'admin/accounting/rate_schedule_cards'

export class RateScheduleGroupsMangementDetailRow extends HTMLElement{
  constructor() {
    super();
  }

  async loadData(){
    let url = `/admin/rate_schedule_groups/${this.rateScheduleGroupId}/rate_schedules`
    let res = await fetch(url);
    this.data = await res.json();
    // console.log('RateScheduleGroupsMangementDetailRow data: ',this.data)
  }
  
  async connectedCallback() {
    this.innerHTML = "<h4 class=\"text-center\"></h4>Loading...</h4>";
    await this.loadData()
    this.innerHTML = `
      <div class="row">
        <template id="additional_charges_template">      
          <div class="content">
            <table class="pricing-table">
              <colgroup>
                <col class="col-headers" />
                <col class="col-data" />
              </colgroup>
              <thead>
                <tr>
                  <td class="info">
                    <p class="title"></p>
                  </td>
                  <th scope="col">
                    <p class="tier">
                      Starting at <span class="price"></span>
                    </p>
                    <p>
                      Monthly fee plus<br />additional usage.
                    </p>
                  </th>
                </tr>
              </thead>
            </table>
          </div>
        </template>

        <div class="billing_plans_container show_three_rate_items_only"></div>
      </div>

      <additional-charges-modal></additional-charges-modal>
      `;


    if (this.data.length === 0) {
      this.renderNoDataMessage()
    }
    else {
      this.renderData()
    }
  }

  renderData() {
    const available_rate_schedules = []
    this.data.map(rate_schedule => {
      available_rate_schedules.push(new RateScheduleCard(rate_schedule))     
    })

    /*
      Create an array of rate schedule cards to display. We only allow 3 max.
      Create an array based on the # of stored rate schedules. Then add any extra
      place holders.
    */
    const MAX_RATE_SCHEDULES_ALLOWED = 3
    // force array to only show 3 rate schedule cards
    if (this.data.length > MAX_RATE_SCHEDULES_ALLOWED) {
      available_rate_schedules.length = MAX_RATE_SCHEDULES_ALLOWED
    }

    const billing_plans_container = this.querySelector('.billing_plans_container');
    if (billing_plans_container){
      available_rate_schedules.map(rate_schedule => {
        billing_plans_container.appendChild(rate_schedule)        
      })


      // listener to change billing plans and re-render ui elements.
      // This is not needed for this element.
      // this.querySelectorAll(".pricing-card ").forEach( element => {
      //   element.addEventListener("click", function (e) {
      //     e.preventDefault();
      //   }.bind(this));  
      // }) 
    }
  }

  renderNoDataMessage() {
    this.innerHTML=`
        <span>No rate schedules found.</span>
    
    `
  }
}
customElements.define("rate-schedule-groups-management-detail-row", RateScheduleGroupsMangementDetailRow)
